import { formsApi } from './api';

export default ({ fullName, email, message, userStatus }) => {
  const body = {
    toAddress: 'support@fairview-rewards.com',
    subject: 'Contact Page Form',
    textBody: `Name: ${fullName}\\nEmail: ${email}\\n${userStatus}\\n\\n${message}\\n`,
    htmlBody: `<h2>Name: ${fullName}</h2><h2>Email: ${email}</h2><h2>${userStatus}</h2></br><p>${message}</p>`,
  };

  return formsApi.post('https://forms.fairview-ads.com/submit', body);
};
